import { Show, Image, Center, Box } from "@chakra-ui/react";

import { IIndexable } from "@customtypes/common";
import { StrapiSectionDetail } from "@customtypes/global";

import { getImageUrl } from "@utils/common";
import { trackEvent } from "@utils/firebase";

import { WATCH_HOW_IT_WORKS } from "@constants/analytics";

import Section from "../Section";

interface HowItWorksProps {
  sectionDetails: StrapiSectionDetail;
  imgKey?: string;
  link?: string;
}

const getWorksIllustration: IIndexable = {
  ethWorks: {
    web: "/assets/images/works/works-web.svg",
    mobile: "/assets/images/works/works-mobile.svg",
  },
};

const How = ({ sectionDetails, imgKey, link }: HowItWorksProps) => {
  return (
    <Section
      title={sectionDetails.title}
      subTitle={sectionDetails.sub_title}
      id={sectionDetails.section_id}
    >
      {link && (
        <>
          <Show above="lg">
            <Box
              mt="2rem"
              borderRadius="24px"
              overflow="hidden"
              onClick={() => trackEvent(WATCH_HOW_IT_WORKS)}
            >
              <iframe
                width="571"
                height="299"
                src={link}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </Box>
          </Show>
          <Show breakpoint="(max-width: 991px)">
            <Box
              mt="2rem"
              borderRadius="24px"
              overflow="hidden"
              onClick={() => trackEvent(WATCH_HOW_IT_WORKS)}
            >
              <iframe
                width="328"
                height="171"
                src={link}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </Box>
          </Show>
        </>
      )}
      {imgKey && getWorksIllustration[imgKey] ? (
        <Center>
          <Show above="lg">
            <Image
              mt="10px"
              src={getImageUrl(getWorksIllustration[imgKey].web)}
              h="806px"
              alt="how-it-works"
            />
          </Show>

          <Show below="lg">
            <Image
              mt="40px"
              src={getImageUrl(getWorksIllustration[imgKey].mobile)}
              h="296px"
              alt="how-it-works"
            />
          </Show>
        </Center>
      ) : null}
    </Section>
  );
};

export default How;
